import { useEffect } from 'react';
import { isAndroid } from '../native/platform';

// Tracks the mobile visual viewport (the area NOT covered by the on-screen
// keyboard) and exposes it as the CSS variable --vvh on :root.
//
// Use `max-h-[min(var(--vvh,100dvh),<original>)]` (or similar) on modal
// containers so a sticky footer stays above the keyboard.
//
// The Android app resizes its whole window for the keyboard (capacitor.config.json,
// Keyboard resize "native"), so there the window's height is the area: while the keyboard
// slides in, the visual viewport is for a moment only the part above it before the window
// shrinks (165px of 500), and a form that followed it shrank so far that the browser
// scrolled its focused field into view, hiding the new task's title under the header.
export function useVisualViewport() {
  useEffect(() => {
    if (typeof window === 'undefined' || !window.visualViewport) return;
    const vv = window.visualViewport;
    const root = document.documentElement;
    const windowSized = isAndroid();

    const update = () => {
      root.style.setProperty('--vvh', `${windowSized ? window.innerHeight : vv.height}px`);
      root.style.setProperty('--vv-offset-top', `${vv.offsetTop}px`);
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);

    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);
}
